import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import classNames from "classnames";
import * as podiumCoreIconsModule from "@nike/nike-design-system-icons";
const podiumCoreIcons = { ...podiumCoreIconsModule };
const podiumCoreIconNames = Object.keys(podiumCoreIcons);
const sizingMap = new Map([
    ["s", 16],
    ["m", 24],
    ["l", 48],
]);
/**
 * @deprecated
 * The Icon component is deprecated and will be removed in a future release.
 * We recommend using specific icons from the @nike/nike-design-system-icons package directly instead.
 * See https://eds.nike.com/#/components/icons/Icon
 */
export const Icon = ({ name, size = "m", backgroundColor, backgroundShape, className, enableFocus, color, "aria-label": ariaLabel = name, ...rest }) => {
    const svgSize = sizingMap.get(size);
    const createIconComponent = () => React.createElement(podiumCoreIcons[name], {
        width: svgSize,
        height: svgSize,
        className: classNames("eds-icon", `eds-icon--${name.toLowerCase()}`, className),
        color,
        ...rest,
    });
    // @todo add better error handling if icon string is not in icon array
    if (!podiumCoreIconNames.includes(name))
        return null;
    const tabIndexProps = enableFocus ? { tabIndex: 0 } : {};
    if (backgroundShape) {
        return (_jsx("div", { ...tabIndexProps, "aria-label": ariaLabel, role: "img", className: classNames("eds-icon__wrapper", `eds-icon__wrapper--${backgroundShape}`, `eds-icon__wrapper--${size}`, `eds-icon__wrapper--${name.toLowerCase()}`), style: {
                backgroundColor,
            }, children: createIconComponent() }));
    }
    return createIconComponent();
};
